import { useOrderStore } from 'modules/orders/store'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export const useRecalculeTaxes = (input: any) => {
  const { formData } = input
  const pageLocation = useLocation()
  const isDuplicatePage = pageLocation.pathname.includes('/duplicate')

  const setIsTaxesRecalculePending =
    useOrderStore.useSetIsTaxesRecalculePending()

  useEffect(() => {
    if (isDuplicatePage) return

    setIsTaxesRecalculePending(true)
  }, [
    formData?.customer,
    formData?.freightPrice,
    formData?.orderType,
    formData?.paymentTerm,
    formData?.items,
    formData?.unity,
    formData?.totalDiscount,
    formData?.totalExpenses,
    isDuplicatePage,
    setIsTaxesRecalculePending
  ])
}
